import React from "react";
import { useI18n } from "../../i18n/I18nProvider";
import { BASE_TRACKER_URL } from "../../utils/constants";
import { useUser } from "../../hooks/useUser";

interface ClaimButtonProps {
  onClick: () => void;
  canBeClaimed?: boolean;
  isClaimed: boolean;
  points: number;
}

const ClaimButton: React.FC<ClaimButtonProps> = ({
  onClick,
  canBeClaimed = true,
  isClaimed,
  points,
}) => {
  const { t } = useI18n();
  const { user } = useUser();

  const isClaimable = user?.dailyPointsProgress
    ? user?.dailyPointsProgress + points <= 2500
    : true;

  const getBackgroundColor = () => {
    if (isClaimed) return "var(--color-success)";
    if (!isClaimable) return "var(--color-secondary)";
    return "var(--color-primary)";
  };

  const handleClick = () => {
    if (canBeClaimed && !isClaimed) {
      onClick();
    }
  };

  return (
    <div
      className="h-6 w-full rounded text-white text-center flex items-center justify-center"
      style={{
        marginTop: "auto",
        background: getBackgroundColor(),
        fontWeight: 700,
        fontSize: "0.8rem",
        left: 0,
        bottom: 0,
        cursor: canBeClaimed && !isClaimed ? "pointer" : "not-allowed",
        opacity: canBeClaimed ? 1 : 0.5,
      }}
      onClick={handleClick}
    >
      {isClaimed ? (
        <div>{t("Claimed")}</div>
      ) : !isClaimable ? (
        <div>{t("ComeBackTomorrow")}</div>
      ) : (
        <div className="flex items-center" style={{ flexDirection: "row" }}>
          <div style={{ fontWeight: 400 }}>{t("Claim")}</div>
          {points !== undefined && points > 0 && (
            <div style={{ margin: "0 0.3rem", fontWeight: 700 }}>{points}</div>
          )}
          <img
            src={`${BASE_TRACKER_URL}/coin.svg`}
            alt="coin"
            style={{
              width: "1rem",
              height: "1rem",
              marginLeft: "0.1rem",
              display: "inline-block",
              verticalAlign: "middle",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ClaimButton;
